import {fetchBaseQuery, FetchBaseQueryError} from '@reduxjs/toolkit/query/react';
import {config} from '../../services/config';
import {isRejectedWithValue, Middleware, MiddlewareAPI} from "@reduxjs/toolkit";
import {redirect} from "react-router-dom";

const baseQuery = fetchBaseQuery({
    baseUrl: config.BASE_URL,
    prepareHeaders: (headers, {getState, endpoint}) => {
        const accessToken = localStorage.getItem('AccessToken');
        if (accessToken && endpoint !== 'login') {
            headers.set('Authorization', `Bearer ${accessToken}`);
        }
        headers.set('Access-Control-Allow-Origin', '*');
        return headers;
    },
});

// Custom wrapper around baseQuery
export const baseQueryWithAuthRedirect: typeof baseQuery = async (args, api, extraOptions) => {
    const result = await baseQuery(args, api, extraOptions);

    if (result.error && (result.error as FetchBaseQueryError).status === 401) {
        window.location.href = '/login'; // Adjust the URL if your login route is different
    }

    return result;
};


export const rtkQueryErrorLogger: Middleware =
    (auth: MiddlewareAPI) => (next) => (action: any) => {
        if (isRejectedWithValue(action)) {
            if (action.payload.status === 401 || action.payload.status === 403) {
                console.log('Bad permissions')
                redirect('/login')
            }
        }

        return next(action)
    }


export const prepareHeaders = (headers: any, {getState, endpoint}: any) => {
    const accessToken = localStorage.getItem('AccessToken')
    if (accessToken && endpoint !== 'login') {
        headers.set('Authorization', `Bearer ${accessToken}`)
    }
    return headers
}